import type { UserPermissionValues } from "Infrastructure/Components/PermissionGuard";
import type { ChipPropsColorOverrides } from "@mui/material";
import type { ElementType } from "react";

export enum MenuItemTypes {
	Settings = "settings",
	Users = "users",
	UsersCreate = "users-create",
	UsersProfile = "users-profile",
	UsersRoles = "users-roles",
	MyProfile = "my-profile",
	Markets = "markets",
	Orders = "orders",
	OrdersList = "orders-list",
	Invoices = "invoices",
	VerticalSetup = "vertical-setup",
	Partners = "partners",
	PartnersList = "partners-list",
	PartnersStatistics = "partners-statistics",
	Claims = "claims",
	Company = "company",
	Payments = "payments",
	Calendar = "calendar",
	PartnershipRecords = "partnership-records",
}

export interface MenuItemsType {
	id?: string;
	navlabel?: boolean;
	subheader?: string;
	title?: MenuItemTypes;
	subtitle?: string;
	disabled?: boolean;
	icon?: ElementType;
	level?: number;
	href?: string;
	children?: MenuItemsType[];
	chip?: string;
	permission?: UserPermissionValues | UserPermissionValues[];
	chipColor?:
		| "secondary"
		| "default"
		| "primary"
		| "error"
		| "info"
		| "success"
		| ("warning" & ChipPropsColorOverrides);
	variant?: "filled" | "outlined";
	external?: boolean;
}
